import { differenceInDays } from "date-fns";

export function getWeekOfYearFromDayWeek(dateWeek) {
    let firstDate = new Date(dateWeek.from.getFullYear(), 0, 7);

    let addDay = 6 - firstDate.getDay();
    let endDateWeekOne = new Date(firstDate.getTime() + (addDay * 24 * 60 * 60 * 1000));

    let diff = differenceInDays(dateWeek.from, endDateWeekOne);

    return {
        week: (diff + 13) / 7,
        year: dateWeek.from.getFullYear(),
        from: dateWeek.from,
        to: dateWeek.to
    }
}

export const getDayWeek = (date) => {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    let addDate = (6 - date.getDay()) * 24 * 60 * 60 * 1000;
    let minusDate = (date.getDay() - 0) * 24 * 60 * 60 * 1000;

    let endDateWeek = new Date((date.getTime() + addDate));
    let startDateWeek = new Date((date.getTime() - minusDate));

    let selectedWeek = {
        from: startDateWeek,
        to: endDateWeek
    }
    return selectedWeek;
}

export const getWeekOfYear = (date) => {
    const dayWeek = getDayWeek(date);
    const woy = getWeekOfYearFromDayWeek(dayWeek);
    return woy;
}